import { BaseFetch } from "../main-model"
export default class CriterionModel extends BaseFetch {
  getCriterionBy = (data) =>
    this.authFetch({
      url: "criterion/getCriterionBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getCriterionById = (data) =>
    this.authFetch({
      url: "criterion/getCriterionById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateCriterionById = (data) =>
    this.authFetch({
      url: "criterion/updateCriterionById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertCriterion = (data) =>
    this.authFetch({
      url: "criterion/insertCriterion",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteCriterionById = (data) =>
    this.authFetch({
      url: "criterion/deleteCriterionById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
